<template>
  <w-icon-wrapper
    :width='21.6'
    :height='24'
    icon-name='work-nav-product-icon'
    view-box='0 0 21.6 24'
  >
    <path
      id="_04_Produkte_Icon"
      data-name="04_Produkte_Icon"
      d="M129.6-859.09v-8.22l-7.2-4.17v8.22Zm2.4,0,7.2-4.17v-8.22l-7.2,4.17Zm-2.4,2.76-8.4-4.83a2.385,2.385,0,0,1-.885-.87,2.338,2.338,0,0,1-.315-1.2v-9.54a2.338,2.338,0,0,1,.315-1.2,2.384,2.384,0,0,1,.885-.87l8.4-4.83a2.36,2.36,0,0,1,1.2-.33,2.36,2.36,0,0,1,1.2.33l8.4,4.83a2.385,2.385,0,0,1,.885.87,2.338,2.338,0,0,1,.315,1.2v9.54a2.338,2.338,0,0,1-.315,1.2,2.385,2.385,0,0,1-.885.87l-8.4,4.83a2.36,2.36,0,0,1-1.2.33A2.36,2.36,0,0,1,129.6-856.33Zm6-15.84,2.31-1.32-7.11-4.11-2.34,1.35Zm-4.8,2.79,2.34-1.35-7.11-4.11-2.34,1.35Z"
      transform="translate(-120 880)"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNavProduct' };
</script>

